"use client";

import { FC } from "react";
import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";

export interface ProfileRowProps {
  /** OspIcons name */
  icon: string;
  /** 行标题 */
  title: string;
  /** 可选副标题 */
  subtitle?: string;
  /** 右侧自定义内容（默认 chevron-right） */
  trailing?: React.ReactNode;
  /** 点击处理 */
  onClick?: () => void;
  /** danger 样式用于 logout */
  variant?: "default" | "danger";
  /** 额外 className */
  className?: string;
}

export const ProfileRow: FC<ProfileRowProps> = ({
  icon,
  title,
  subtitle,
  trailing,
  onClick,
  variant = "default",
  className,
}) => {
  return (
    <div
      className={cn(
        "flex items-center px-4 py-3 cursor-pointer hover:bg-background_white_overlay5",
        className,
      )}
      onClick={onClick}
    >
      <div className="w-10 h-10 rounded-2 bg-background_white_overlay5 flex items-center justify-center shrink-0">
        <OspIcons
          name={icon}
          size={20}
          className={cn(
            "text-content_primary",
            variant === "danger" && "text-content_critical",
          )}
        />
      </div>
      <div className="ml-3 flex-1 min-w-0">
        <div
          className={cn(
            "body_medium_m text-content_primary",
            variant === "danger" && "text-content_critical",
          )}
        >
          {title}
        </div>
        {subtitle && (
          <div className="body_regular_xs text-content_secondary">
            {subtitle}
          </div>
        )}
      </div>
      {trailing !== null &&
        (trailing ?? (
          <Icon
            name="chevron-right"
            size={20}
            className="text-content_tertiary shrink-0"
          />
        ))}
    </div>
  );
};
